import React, { Component } from "react";

class SwitchToRtl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dirAttribute: "ltr",
    };

    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  componentDidMount() {
    const storedDirAttribute = localStorage.getItem("dirAttribute");
    if (storedDirAttribute) {
      this.setState({ dirAttribute: storedDirAttribute });
      document.documentElement.setAttribute("dir", storedDirAttribute);
    }
  }

  handleButtonClick() {
    const { dirAttribute } = this.state;
    const newDirAttribute = dirAttribute === "ltr" ? "rtl" : "ltr";
    this.setState({ dirAttribute: newDirAttribute });
    localStorage.setItem("dirAttribute", newDirAttribute);
    document.documentElement.setAttribute("dir", newDirAttribute);
  }

  render() {
    return (
      <div>
        <button
          onClick={this.handleButtonClick}
          className="rtl-switcher"
        >
          Switch to RTL/LTR
        </button>
      </div>
    );
  }
}

export default SwitchToRtl;
